<template>
	<div class="home">
		<!-- 顶部欢迎及注册登录按钮导航 -->
		<header-top />
		<!-- 顶部公司logo及导航栏 -->
		<logo-head></logo-head>
		<!-- 导航栏 -->
		<NavHead></NavHead>
		<!-- banner轮播图 -->
		<div class="home_banner">
			<!-- 右侧知识产权研究院入口 -->
			<div class="rightYjy">
				<img src="../assets/img/home/homeBannerRight.png" style="width:440px;">
				<div style="width: 440px;height:220px;box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04);margin-top:10px;">
					<div class="d-flex" style="border-bottom: 1px solid #eee;font-size: 16px;">
						<div style="width: 360px;height:50px;color: #C32A1A;line-height: 50px;padding-left: 15px;">
							行业资讯
						</div>
						<div style="line-height:50px;font-size:14px;color: #C8CBCF;padding-top:2px;cursor: pointer;"
						@click="$router.push('/newsInformation')">查看更多</div>
					</div>
					<!-- 新闻列表 -->
					<div class="ml-3 mt-2" v-for="(item,index) in newsList" :key="index">
						<p @click="goNewsDetail(item)" class="newsHover">{{item.name}}</p>
					</div>
				</div>
			</div>
			<div class="leftBanner">
				<video src="../assets/video/hdVideo.mp4" controls autoplay="autoplay" style="width:750px;height:420px;object-fit: fill;"
				poster="../assets/img/home/homeVideoBg.png" ></video>
			</div>
		</div>
		<!-- 首页二级图片菜单矩阵 -->
		<div class="imgNavList">
			<img src="../assets/img/home/service_img1.png" @click="goServiceList(2)">
			<img src="../assets/img/home/service_img2.png" @click="goServiceList(3)">
			<img src="../assets/img/home/service_img3.png" @click="goServiceList(1)">
			<img src="../assets/img/home/service_img4.png" @click="goServiceList(4)">
		</div>
		<!-- 热门推荐 -->
		<div class="hotRecommended">
			<div>
				<!-- 热门商标 -->
				<PopularTab titleName="热门商标" titleEngName="POPULAR TRADEMARK" class="mt-4" moreLinkUrl="/brand">
					<showCardSkeleton v-show="tradeLoading"></showCardSkeleton>
					<div v-for="(item,index) in hotBrand" class="d-inline-block mt-4 hot_card_list" :key="index" v-show="!tradeLoading">
						<show-card :imgUrl="item.logoUrl" :titleDesc="item.name" :patentType="item.type"
						:price="item.chargeAmount == '面议' ? item.chargeAmount : '￥'+ item.chargeAmount " @click="goodsShow(item.id,'商标交易','/brand','brand')"></show-card>
					</div>
				</PopularTab>
			</div>
				<div style="margin-top:35px;margin-bottom:15px;">
				<!-- 热门专利 -->
				<PopularTab titleName="热门专利" titleEngName="POPULAR PATENT" moreLinkUrl="/patent">
					<showCardSkeleton v-show="patentLoading"></showCardSkeleton>
					<div v-for="(item,index) in hotPatent" class="d-inline-block mt-4 hot_card_list" :key="index" v-show="!patentLoading">
						<show-card :imgUrl="item.logoUrl" :titleDesc="item.name" :price="item.chargeAmount == '面议' ? item.chargeAmount : '￥'+ item.chargeAmount " :patentType="item.patentType"
						 @click="goodsShow(item.id,'专利交易','/patent','patent')"></show-card>
					</div>
				</PopularTab>
				</div>
		</div>
		<!-- 专家咨询 -->
		<div class="expert">
			<div style="margin: 0 auto;width: 1200px;margin-top:20px;cursor: pointer;" @click="goLink('/irpi')">
				<img src="../assets/img/home/zscqyjy.png">
			</div>
			<ModuleTitle titleName="领域专家介绍" titleEngName="DOMAIN EXPERT CONSULTATION" class="pt-4"></ModuleTitle>
				<!-- 专家卡片 -->
				<div class="expertCardList">
					<div class="d-flex listArr">
						<div v-for="(item,index) in expertArr" class="expertCard mr-5 text-center" :key="item.id">
							<div class="mt-3">
								<div class="expertImg">
									<!-- 专家照片 -->
									<img :src="item.logoUrl" width="160" height="160">
								</div>
								<div class="mt-2">
									<!-- 专家姓名 -->
									<div class="expertName">
										<h4>{{item.name}}</h4>
									</div>
									<!-- 专家职位 -->
									<div class="expertWork">
										<span>{{item.unitName}}</span>
									</div>
									<!-- 了解详情 -->
									<div class="expertButton">
										<el-button color="#C32A1A" plain @click="goExpertPage(item.id)">了解详情</el-button>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
		</div>
		<!-- 服务客户 -->
		<div class="customList">
			<div class="aboutUs">
				<!-- 主体 -->
				<div class="aboutContent">
					<ModuleTitle titleName="部分合作伙伴" titleEngName="Some Partners"></ModuleTitle>
					<!-- 合作伙伴图片列表 -->
					<div class="partList">
						<ul>
							<li v-for="(item,index) in partners" :key="index">
								<img :src="item.url" width="202" height="60">
							</li>
						</ul>
					</div>
				</div>
			</div>
		</div>
		<!-- 资质认证 -->
		<div class="qualification">
			<ModuleTitle titleName="资质认证" titleEngName="Qualification certification" class="pt-4"></ModuleTitle>
			<!-- 证书排列矩阵 -->
			<div class="quaArrList">
				<!-- 左侧长图 -->
				<div style="float: left;width: 270px;" v-for="(item,index) in quaArr" :key="index">
					<img :src="item.url"  v-show="item.verticalChart == '竖图'" width="265" height="360">
				</div>
				<!-- 右侧排列 -->
				<div style="float: left;width: 900px;margin-left: 10px;">
					<div class="qualist">
						<img v-for="(item,index) in quaArr" :key="index"
						:src="item.url" v-show="item.verticalChart == '横图'" width="253" height="175">
					</div>
				</div>
			</div>
		</div>
		<!-- 底部导航 -->
		<div>
			<Footer></Footer>
		</div>
	</div>
</template>

<script>
	import {
		ref,
	} from 'vue'
	import HeaderTop from '@/components/headerTop/headerTop.vue'
	import LogoHead from '@/components/logoHead/logoHead.vue'
	import NavHead from '@/components/navHead/navHead.vue'
	import ModuleTitle from '@/components/moduleTitle/moduleTitle.vue'
	import PopularTab from '@/components/popularTab/popularTab.vue'
	import showCard from '@/components/showCard/showCard.vue'
	import Footer from '@/components/footer/footer.vue'
	import showCardSkeleton from '@/components/skeleton/showCard.vue'
	export default {
		name: 'Home',
		components: {
			HeaderTop,
			LogoHead,
			NavHead,
			ModuleTitle,
			PopularTab,
			showCard,
			Footer,
			showCardSkeleton
		},
		setup() {
			// 首页加载banner骨架屏loading
			let homeBannerLoading = ref(false)
			//  行业资讯
			let newsList = ref([])
			// 热门专利loading
			let patentLoading = ref(false)
			// 热门商标loading
			let tradeLoading = ref(false)
			// 导航菜单
			const activeIndex = ref('1')
			// 图片导航菜单
			const imgNavArr = ref([
				{url:'../assets/img/home/service_img1.png'},
				{url:'../assets/img/home/service_img2.png'},
				{url:'../assets/img/home/service_img3.png'},
				{url:'../assets/img/home/service_img4.png'},
			])
			// 轮播图数组
			let bannerArr = ref([''])
			// 热门专利
			let hotPatent = ref([])
			// 热门专利
			let hotBrand = ref([])
			// 专家
			let expertArr = ref([])
			// 服务客户
			let partners = ref([])
			// 资质认证图片
			let quaArr = ref([
				// {url:'../assets/img/home/quaImg_01.jpg'},
				// {url:'../assets/img/home/quaImg_02.jpg'},
				// {url:'../assets/img/home/quaImg_03.jpg'},
				// {url:'../assets/img/home/quaImg_04.jpg'},
				// {url:'../assets/img/home/quaImg_05.jpg'},
				// {url:'../assets/img/home/quaImg_06.jpg'}
			])
			return {
				homeBannerLoading,
				newsList,
				patentLoading,
				tradeLoading,
				activeIndex,
				imgNavArr,
				bannerArr,
				hotPatent,
				hotBrand,
				expertArr,
				partners,
				quaArr,
			}
		},
		created() {
			this.getHotBrand()
			// 获取热门推荐-热门专利数据
			this.getHotPatent()
			// 获取领域专家咨询
			this.getNewsInformation()
			this.getExpert()
			// 获取合作伙伴
			this.getPartners()
			// 获取资质
			this.getqualification()
		},
		mounted() {

		},
		methods: {
			// 进入页面公共方式
			goLink(linkUrl){
				let routeData = this.$router.resolve({
					path:linkUrl
				})
				window.open(routeData.href, '_blank');
			},
			// 基础服务主页矩阵
			goServiceList(index){
				let routeData = this.$router.resolve({
					path:'/serviceList',
					query:{
						index
					}
				})
				window.open(routeData.href, '_parent');
			},
			// 获取热门推荐-热门专利数据
			getNewsInformation(){
				let vm = this
				// 区分分页与查询
				this.axios.get('/api/industry/new/findAllByPage',{params:{
					currPage: 1,
					everySize: 4,
					type:'知产资讯'
				}}).then(res => {
					vm.newsList = res.data.data.industryNews
				})
			},
			// 获取热门推荐-热门专利数据
			getHotPatent(){
				let vm = this
				vm.patentLoading = true
				vm.tradeLoading = true
				this.axios.get('/api/patent/home/findHotPatent').then(res => {
					vm.hotPatent = res.data.data
					vm.patentLoading = false
					vm.tradeLoading = false
				})
			},
			// 获取热门推荐-热门商标数据
			getHotBrand(){
				let vm = this
				vm.patentLoading = true
				vm.tradeLoading = true
				this.axios.get('/api/brand/home/findHotBrand').then(res => {
					vm.hotBrand = res.data.data
					vm.patentLoading = false
					vm.tradeLoading = false
				})
			},
			// 进入商品详情页
			goodsShow(id,mbx,mbxLink,type){
				let routeData = this.$router.resolve({
					path:'/goodsInfo',
					query:{
						id:id,
						mbx:mbx,
						mbxLink:mbxLink,
						type:type
					}
				})
				window.open(routeData.href, '_blank');
			},
			// 点击后前往新闻详情页
			goNewsDetail(item){
				if(item.reprintMark){
					return window.open(item.reprintUrl, '_blank');
				}
				let routeData = this.$router.resolve({
					path:'/newsDetail',
					query:{
						id:item.id,
						mbx:'行业资讯',
						mbxLink:'/newsInformation'
					}
				})
				window.open(routeData.href, '_blank');
			},
			// 获取领域专家咨询
			getExpert(){
				let vm = this
				this.axios.get('/api/expert/home/findExpert').then(res => {
					vm.expertArr = res.data.data
				})
			},
			// 进入员工详情页
			goExpertPage(index){
				let routeData = this.$router.resolve({
					path:'/expertDesc',
					query:{
						index
					}
				})
				window.open(routeData.href, '_blank');
			},
			// 获取合作伙伴
			getPartners(){
				let vm = this
				this.axios.get('/api/customer/homeFindCustomer').then(res => {
					vm.partners = res.data.data
				})
			},
			// 获取资质
			getqualification(){
				let vm = this
				this.axios.get('/api/qualification/home/findQualification').then(res => {
					vm.quaArr = res.data.data
				})
			}
		},
	}
</script>
<style scoped>
	/* 图片大小默认 */
	img {
		max-width: 100%;
		max-height: 100%;
	}

	/* 主页轮播图 */
	.home_banner {
		width: 1200px;
		height: 360px;
		margin: 0 auto;
		display: flex;
		margin-bottom:30px;
	}
	.newsHover{
		cursor: pointer;
	}
	.newsHover:hover{
		color: #C32A1A;
	}
	/* 左侧轮播图 */
	.home_banner .leftBanner {
		width: 800px;
		height: 420px;
		margin-top:7.5px;
	}

	/* 右侧知识产权研究院宣传图 */
	.home_banner .rightYjy {
		width: 440px;
		height: 360px;
		margin-top:8px;
		margin-right: 10px;
	}
	/* 首页二级图片菜单矩阵 */
	.imgNavList{
		width: 1200px;
		height:100px;
		margin: 0 auto;
		margin-top:85px;
		display: flex;
	}
	.imgNavList img{
		cursor:pointer;
	}
	.imgNavList img:not(:last-child){
		padding-right: 21px;
	}
	/*  */
	/* 热门推荐 */
	.hotRecommended{
		width: 100%;
		min-height:700px;
		background-color:#f7f7f7;
		margin-top: 20px;
		overflow: hidden;
	}
	.hot_card_list:not(:last-child){
		margin-right:20px;
	}
	/* 知识产权联盟、研究院 */
	.lm_yjy{
		width: 1200px;
		height:342px;
		margin:0 auto;
		margin-top:60px;
		display: flex;
		justify-content: space-between;
		background-color: #fff;
		border-top:3.5px solid #c26eff;
	}
	.lm_yjy .lm,
	.lm_yjy .yjy{
		width: 600px;
		height: 342px;
		border: 1px solid #dedede;
	}
	.lm_yjy .yjy{
		border-left: none;
	}
	.lm_yjy .lm .lm-head,
	.lm_yjy .yjy .yjy-head{
		width: 600px;
		height:70px;
		line-height:70px;
		display: flex;
		justify-content: space-between;
	}
	.lm_yjy .lm .imgLister,
	.lm_yjy .yjy .imgLister{
		display: flex;
		justify-content: center;
		margin-top:10px;
		margin-left:12px;
	}
	/* 专家介绍 */
	.expert{
		width: 100%;
		min-height: 500px;
	}
	.expert .expertCardList{
		width: 1200px;
		height: 330px;
		margin: 0 auto;
		margin-top: 30px;
		position: relative;
	}
	.expert .expertCardList .listArr{
		margin-left:70px;
	}
	.expert .expertCardList .expertCard{
		width: 234px;
		height: 326px;
	}
	.expertImg img{
		border-radius: 50%;
		border: 1px solid #eee;
	}
	.expertWork{
		color:#666
	}
	.expertButton{
		width: 234px;
		position: absolute;
		bottom: 30px;
	}
	/* 合作伙伴 */
	.aboutUs{
		background:url(../assets/img/home/aboutUsBg.png) no-repeat;
		width: 100%;
		height: 450px;
		background-size:100% 450px;
		background-position:top center;
		background-attachment:scroll;
	}
	.aboutUs .aboutContent{
		width: 1200px;
		height: 500px;
		margin:0 auto;
		position: relative;
		top:10px;
	}
	.aboutUs .aboutContent .aboutTitle{
		font: 26px/40px 'Microsoft Yahei';
		color: #333333;
		text-align: center;
		font-weight: bold;
	}
	.aboutUs .aboutContent .titleDesc{
		margin-top: 10px;
		font: 14px/20px 'Microsoft Yahei';
		color: #666;
		text-align: center;
	}
	.aboutUs .aboutContent .partList{
		width: 1200px;
		height: 400px;
		margin-top:20px;
	}
	.aboutUs .aboutContent .partList ul{

	}
	.aboutUs .aboutContent .partList ul li{
		width: 202px;
		height: 60px;
		background-color: #fff;
		display: inline-block;
		margin-right: 30px;
		margin-bottom:20px;
		border-right: 1px solid #dedede;
		border-bottom: 1px solid #dedede;
	}
	.aboutUs .aboutContent .partList ul li:hover{
		transform: scale(1.05,1.05);
		box-shadow: 0 0 10px #dedede;
	}
	/* 交易流程 */
	.process{
		width: 100%;
		margin-bottom:30px;
	 }
	/* 资质认证 */
	.qualification{
		width: 100%;
		height: 500px;
		/* background-color: #F7F7F7; */
		margin-bottom:24px;
	}
	/* 认证矩阵 */
	.quaArrList{
		width: 1200px;
		height: 350px;
		margin: 0 auto;
		margin-top:20px;
		position: relative;
		left: 70px;
	}
	.qualist img{
		margin-bottom: 10px;
		margin-right:10px;
	}
</style>
